module.exports = __webpack_public_path__ + "static/media/cloud_infra.95dde2d8.png";